import { REPORT_PATHS, reportGroupsList } from '@/config/reportGroups'

export const REPORTS_HOME = '/reports'

export const buildReportsNavItems = ({ hideNumbers = false } = {}) => {
  if (hideNumbers) return []
  return [
    { name: 'Overview', link: REPORTS_HOME, exact: [REPORTS_HOME] },
    ...reportGroupsList
      .filter(group => group.reports.length)
      .map(group => ({
        name: group.title,
        link: group.reports[0].to,
        exact: group.reports.map(report => report.to),
        children: group.reports.map(report => ({ name: report.name, link: report.to, exact: [report.to] }))
      }))
  ]
}

export default {
  bases: [REPORTS_HOME, ...REPORT_PATHS],
  fetches: [],
  build: buildReportsNavItems
}
